/* eslint-disable react/prop-types */
import React from "react";

function Button({ children }) {
  return (
    <button
      style={{
        padding: "4px 10px",
      }}
    >
      {children}
    </button>
  );
}

const Actions = () => {
  return (
    <div
      style={{
        position: "fixed",
        bottom: 0,
        right: 0,
        minWidth: 300,
        zIndex: 9999999,
        border: "1px solid black",
        background: "#fff",
        display: "flex",
        gap: 5,
        padding: 4,
      }}
    >
      <Button>Tải bảng kê</Button>
      <Button>Nhập lại</Button>
      <Button>Ghi</Button>
      <Button>In</Button>
      <Button>Xóa</Button>
      <Button>Kết xuất</Button>
      <Button>Nhập từ XML</Button>
      <Button>Đóng</Button>
    </div>
  );
};

export default Actions;
